// Admin auth helpers.
//
// The backend issues BOTH an httpOnly `tandaa_admin` cookie *and* an access_token in
// the response body on /api/admin/login. Cookies are the correct production choice
// (immune to XSS extraction), but the current preview infrastructure's edge proxy
// rewrites `Access-Control-Allow-Origin` to `*`, which the browser refuses to combine
// with `credentials: 'include'`. Until the site is served from a single domain,
// the client uses the Bearer header path.
//
// On a single-domain production deployment, switch this file to:
//   - drop the localStorage layer entirely
//   - call adminFetch with `credentials: 'include'`
//   - check session via GET /api/admin/me
// The backend already supports both paths; no server change is required.

const KEY = "tandaa.admin.token";

export const getAdminToken = () => {
  try {
    return localStorage.getItem(KEY) || null;
  } catch (e) {
    console.error("localStorage read failed", e);
    return null;
  }
};

export const setAdminToken = (t) => {
  try {
    localStorage.setItem(KEY, t);
  } catch (e) {
    console.error("localStorage write failed", e);
  }
};

export const clearAdminToken = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    console.error("localStorage clear failed", e);
  }
};

export const adminFetch = (url, options = {}) => {
  const token = getAdminToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(url, { ...options, headers });
};
